export interface IFeature {
  id: number;
  icon: React.ReactNode;
  selectedIcon: React.ReactNode;
  text: string;
  disabled: boolean;
  defaultChecked?: boolean;
  hide?: boolean;
}
export enum FeatureSelectionTab {
  dashboard = 0,
  timer = 1,
  transactions = 2,
  tasks = 3,
  conflictSearch = 4,
  customers = 5,
  matters = 6,
  invoicing = 7,
  workTimes = 8,
  profile = 9,
}

export type StartModule = Exclude<FeatureSelectionTab, FeatureSelectionTab.profile>;

export type FeatureFlags = { [key: string]: boolean };
